import React from 'react'
import PropTypes from 'prop-types'
import MasterData from '../../data/MasterData'
import StationRow from './TrainPositionBranchStationRow'

export default class TrainPositionBranchList extends React.Component {

  static propTypes = {
    lines: PropTypes.array.isRequired,
    trains: PropTypes.array.isRequired,
    lineName: PropTypes.string.isRequired,
    themeName: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
  }

  static contextTypes = {
    intl: PropTypes.object
  }

  stations() {
    const { lineName, lines } = this.props
    const lineId = MasterData.lineIdByBranchLineName(lineName)
    return lines.find(l => l.line_id === lineId).stations
  }

  render() {
    const { lineName, lines, trains, themeName, match, history, lineSwitchItem, transferList } = this.props

    return (
      <ul className="d-TrainPosition-station">

        {this.stations().map((station) => {
          return (
            <StationRow
              key={`station${station.id}`}
              lines={lines}
              lineName={lineName}
              trains={trains}
              station={station}
              themeName={themeName}
              match={match}
              history={history}
              lineSwitchItem={lineSwitchItem}
              transferList={transferList}
            />
          )
        })}
      </ul>
    )
  }
}
